export default {
      id: "vectorStroke-usage",
      viewBox: "0 0 5 8",
      url: __webpack_public_path__ + "sprite.1792148661250.svg#vectorStroke-usage",
      toString: function () {
        return this.url;
      }
    }